/* eslint-disable react/jsx-no-target-blank */
import React from 'react'
import { WhatsApp, Facebook, EmailOutlined, Instagram } from '@material-ui/icons'
import { Box } from '@material-ui/core'
import { useDispatch, useSelector } from 'react-redux'
import { setAlert } from '../../../flux/alert'
import { bool } from 'prop-types'

const Footer = (props) => {
  const dispatch = useDispatch()
  const items = useSelector(state => state.cart)

  function handlePreventLeave (event) {
    if (!!items && !!items.length && !props.disableNotifications) {
      const to = event.currentTarget.href
      event.preventDefault()
      dispatch(setAlert({
        action: () => { window.location = to },
        message: 'Se perderán los estudios agregados al carrito de compras',
        title: '¿Seguro que quieres salir?'
      }))
    }
  }

  return (
    <Box mt={2}>
      <div className='green-line bg-secondary' />
      <footer className="py-5 bg-primary">
        <div className="row texto-menu text-center text-md-left">
          <div className="col-12 col-sm-6 col-md-4 col-lg-3 col-xl-2 pb-2">
              <a href="https://www.laboratoriosiml.com/index.php"><img src="https://www.laboratoriosiml.com/images/iml-laboratorio-medico-logo-footer.svg" alt="Laboratorios IML" style={{ height: '50px' }} /></a>
              <a href="https://iml.sass.com.mx:444/facturacion/" target="_blank" rel="noopener" className="d-block btn btn-secondary order-lg-1 texto-menu px-2 mr-3 mt-4">Facturación</a>
              <br />
              <ul className="list-unstyled d-flex align-items-center justify-content-center mt-2">
                  <li><a href="https://www.laboratoriosiml.com/contacto.php"><EmailOutlined style={{ fontSize: '1.8em', padding: '.1em', boxSizing: 'border-box' }} /></a></li>
                  <li><a href="https://api.whatsapp.com/send?phone=5214428173500&amp;text=" target="_blank"><WhatsApp style={{ fontSize: '1.8em', padding: '.1em', boxSizing: 'border-box' }} /></a></li>
                  <li><a href="https://www.facebook.com/IML-Laboratorio-M%C3%A9dico-102323544687709/" target="_blank"><Facebook style={{ fontSize: '1.8em', padding: '.1em', boxSizing: 'border-box' }} /></a></li>
                  <li><a href="https://www.instagram.com/iml_laboratorios/" target="_blank"><Instagram style={{ fontSize: '1.8em', padding: '.1em', boxSizing: 'border-box' }} /></a></li>
              </ul>
          </div>
          <div className="col-12 col-sm-6 col-md-4 col-lg-3 col-xl-2 pb-2">
              <p className="text-secondary font-weight-bold unidades-link"><a style={{ fontSize: '15px' }} href="https://www.laboratoriosiml.com/sucursales.php#arcos">UNIDAD ARCOS</a></p>
              <p className="text-white mb-0 text-min">
                  <a href="tel:4428173500"> Tel. (442) 817 3500 </a> <br />
                  C. Ramón Rodríguez Familiar #36,
                  Jardines de Querétaro, 76020 Santiago
                  de Querétaro, Qro.
              </p>
          </div>
          <div className="col-12 col-sm-6 col-md-4 col-lg-3 col-xl-2 pb-2">
              <p className="text-secondary font-weight-bold unidades-link"><a style={{ fontSize: '15px' }} href="https://www.laboratoriosiml.com/sucursales.php#centro">UNIDAD CENTRO</a></p>
              <p className="text-white mb-0 text-min">
                  <a href="tel:4422140772"> Tel. (442) 214 0772 </a><br />
                  Urgencias 24hrs. <br />
                  <a href="tel:4423830541"> (442) 383 0541 </a><br />
                  Reforma #23, Col. Centro, Querétaro,
                  Qro. (Dentro de Sanatorio Alcocer).
              </p>
          </div>
            <div className="col-12 col-sm-6 col-md-4 col-lg-3 col-xl-2 pb-2">
              <p className="text-secondary font-weight-bold unidades-link"><a style={{ fontSize: '15px' }} href="https://www.laboratoriosiml.com/sucursales.php#alamos">UNIDAD ÁLAMOS</a></p>
              <p className="text-white mb-0 text-min">
                  <a href="tel:4422042780"> Tel. (442) 204 2780 </a><br />
                  Urgencias 24hrs. <br />
                  <a href="tel:4423809578"> (442) 380 9578 </a><br />
                  Blvd. Bernardo Quintana Arrioja, #11
                  Interior 302, Piso 2, Álamos 2da Secc,
                  Querétaro, 76160.
              </p>
          </div>
          <div className="col-12 col-sm-6 col-md-4 col-lg-3 col-xl-2 pb-2">
              <p className="text-secondary font-weight-bold unidades-link"><a style={{ fontSize: '15px' }} href="https://www.laboratoriosiml.com/sucursales.php#pueblito">UNIDAD EL PUEBLITO</a></p>
              <p className="text-white mb-0 text-min">
                  <a href="tel:4424506014">Tel. (442) 450 6014</a><br />
                  Calle Fray Sebastián de Gallegos, #89,
                  Int. 6, Col. Pueblito, Corregidora,
                  Querétaro. 76904.
              </p>
          </div>
          <div className="col-12 col-sm-6 col-md-4 col-lg-3 col-xl-2 pb-2">
              <p className="text-secondary font-weight-bold unidades-link"><a style={{ fontSize: '15px' }} href="https://www.laboratoriosiml.com/sucursales.php#torre">UNIDAD TORRE ROJA</a></p>
              <p className="text-white mb-0 text-min">
                  <a href="tel:4271222224">Tel. (427) 122 2224 </a><br />
                  Urgencias 24hrs. <br />
                  <a href="tel:4423830541"> (442) 383 0541 </a><br />
                  Clínica Médica Torre Roja Corregidora
                  #235, Centro, San Juan del Río, Qro. 76800.
              </p>
          </div>
          <div className="col-12 col-sm-6 col-md-4 col-lg-3 col-xl-2 pb-2">
              <p className="text-secondary font-weight-bold unidades-link"><a style={{ fontSize: '15px' }} href="https://www.laboratoriosiml.com/sucursales.php#coscami">UNIDAD COSCAMI</a></p>
              <p className="text-white mb-0 text-min">
                  <a href="tel:4423809578">Tel. (442) 380 9578 </a><br />
                  Av. Río Moctezuma #176,
                  Col. San Cayetano, 76807,
                  San Juan del Río, Querétaro.
              </p>
          </div>
          <div className="col-12 col-sm-6 col-md-4 col-lg-3 col-xl-2 pb-2">
              <p className="text-secondary font-weight-bold unidades-link"><a style={{ fontSize: '15px' }} href="https://www.laboratoriosiml.com/sucursales.php#aramil">UNIDAD PLAZA ARAMIL</a></p>
              <p className="text-white mb-0 text-min">
                  <a href="tel:4271156723">Tel. (427) 115 6723 </a><br />
                  Río Galindo #3, San Cayetano,
                  76806, San Juan del Río, Qro.
              </p>
          </div>
          <div className="col-12 col-sm-6 col-md-4 col-lg-3 col-xl-2 pb-2">
              <p className="text-secondary font-weight-bold unidades-link"><a style={{ fontSize: '15px' }} href="https://www.laboratoriosiml.com/sucursales.php#griega">UNIDAD LA GRIEGA</a></p>
              <p className="text-white mb-0 text-min">
                  <a href="tel:4421379035">Tel. (442) 137 9035 </a><br />
                  Av. Emiliano Zapata, San Francisco,
                  La Griega, 76249, La Griega Qro.
              </p>
          </div>
          <div className="col-12 col-sm-6 col-md-4 col-lg-3 col-xl-2 pb-2">
              <p className="text-secondary font-weight-bold unidades-link"><a style={{ fontSize: '15px' }} href="https://www.laboratoriosiml.com/sucursales.php#piq">UNIDAD PIQ</a></p>
              <p className="text-white mb-0 text-min">
                  Urgencias 24 horas <br />
                  <a href="tel:4426539225">(442) 653 9225</a><br />
                  Parque Industrial Querétaro, Check
                  Point Avenida la Montaña, #94, Local 36,
                  Santa Rosa Jáuregui, Qro. 76220.
              </p>
          </div>
          <div className="col-12 col-sm-6 col-md-4 col-lg-3 col-xl-2 pb-2">
              <p className="text-secondary font-weight-bold unidades-link"><a style={{ fontSize: '15px' }} href="https://www.laboratoriosiml.com/sucursales.php#sanjose">UNIDAD SAN JOSÉ</a></p>
              <p className="text-white mb-0 text-min">
                  <a href="tel:4428641517">Tel. (442) 864 1517 </a><br />
                  Av. Constituyentes 302, Hospital San
                  José, Torre 3, 2do piso, Consultorio 209,
                  El Jacal, Santiago de Querétaro, Qro.
              </p>
          </div>
          <div className="col-12 pt-5" style={{ color: '#0FAFAB' }}>
              ®{(new Date().getFullYear())}, Derechos Reservados &nbsp;&nbsp; <a href="https://www.laboratoriosiml.com/images/IML-aviso-de-privacidad.pdf" target="_blank" rel="noopener noreferrer">Aviso de Privacidad</a>
          </div>
        </div>
      </footer>
    </Box>
  )
}

Footer.propTypes = {
  disableNotifications: bool
}

export default Footer
